// src/features/settings/components/stock-locations-panel/StockLocationCreateForm.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Collapse,
  TextField,
} from '@mui/material';
import { Save as SaveIcon } from '@mui/icons-material';
import { FORM_MAX_WIDTH, FormActions, FormSection } from '../../../../components/common/form';

export default function StockLocationCreateForm({ visible, values, errors, loading, onChange, onSubmit, onCancel }) {
  const { t } = useTranslation(['settings', 'common']);

  return (
    <Collapse in={visible}>
      <Box sx={{ maxWidth: FORM_MAX_WIDTH, display: 'flex', flexDirection: 'column', gap: 5, mb: 5 }}>
        <FormSection title={t('settings:stock_locations.dialog.create_title')}>

        <Box display="flex" flexDirection="column" gap={2}>
          <TextField
            label={t('settings:stock_locations.grid.name')}
            value={values.name}
            onChange={(e) => onChange('name', e.target.value)}
            fullWidth
            required
            error={Boolean(errors.name)}
            helperText={errors.name}
          />
          <TextField
            label={t('settings:stock_locations.grid.description')}
            value={values.description}
            onChange={(e) => onChange('description', e.target.value)}
            fullWidth
          />
        </Box>
        </FormSection>
        <FormActions
          onCancel={onCancel}
          onSubmit={onSubmit}
          submitLabel={t('common:buttons.create')}
          submitIcon={<SaveIcon />}
          loading={loading}
        />
      </Box>
    </Collapse>
  );
}
